<template>
  <div v-show="isActive" class="ec-tab-pane">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EcTabPane',

  props: {
    label: { type: String, required: true },
    name: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },

  computed: {
    parentTabs() {
      var parent = this.$parent
      while (parent) {
        if (parent.$options.name === 'EcTabs') return parent
        parent = parent.$parent
      }
      return null
    },
    isActive() {
      return this.parentTabs ? this.parentTabs.value === this.name : false
    },
  },

  created() {
    if (this.parentTabs) {
      this.parentTabs.addPane({ name: this.name, label: this.label, disabled: this.disabled })
    }
  },

  destroyed() {
    if (this.parentTabs) {
      this.parentTabs.removePane(this.name)
    }
  },
}
</script>
